"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsImport = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const button_1 = require("client/components/material/button");
const paper_1 = require("client/components/material/paper");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const multi_select_1 = require("client/components/ui/multi-select");
const store_1 = require("client/modules/patients/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const Backup_1 = require("material-ui-icons/Backup");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const throttle_debounce_1 = require("throttle-debounce");
require("./patients-import.less");
let PatientsImport = class PatientsImport extends react_1.Component {
    constructor() {
        super(...arguments);
        this.cacheRowIndex = -1;
        this.patient = {};
        // @observable
        // siteId: string =
        //   usersStore.user.value && usersStore.user.value.siteId
        //     ? usersStore.user.value.siteId.toString()
        //     : '';
        this.sitesSelectedIds = [];
        this.sitesList = [];
        this.siteSelected = false;
        this.loadSites = throttle_debounce_1.debounce(200, (filterText) => {
            const keyword = filterText ? filterText : "";
            const options = {
                count: 100,
                search: keyword,
                start: 0,
                where: ""
            };
            // sitesListStore.loadSites(options);
            store_2.sitesListStore.loadSitesNoRelation(options);
        });
        this.getMultiSelectValues = () => {
            const selectedItems = [];
            this.sitesList &&
                this.sitesList.map((site, i) => {
                    const item = {
                        id: site.id,
                        label: site.displayName || site.name,
                        value: String(site.id),
                        tokenLabel: site.displayName || site.name
                    };
                    selectedItems.push(item);
                });
            return selectedItems;
        };
        /**
         * Set the ids of the sites selected and set siteSelected to true to show upload modal.
         */
        this.handleClickNext = () => {
            this.sitesSelectedIds = this.sitesList.map(site => site.id);
            this.siteSelected = true;
        };
        // private handleDrop = async (accepted: ImageFile[]) => {
        //   if (accepted.length) {
        //     await patientsStore.parseImportsHeader(accepted, this.siteId);
        //     // store the imported file(s) and the siteId in an object and save it as
        //     // a variable in patientsStore
        //     patientsStore.importedFileAndSiteId = {
        //       accepted,
        //       siteId: this.siteId,
        //     };
        //     RouteManager.transitionTo(`/patients/import/select`);
        //   }
        // };
        this.handleDrop = async (accepted) => {
            if (accepted.length) {
                await store_1.patientsStore.parseImportsHeader(accepted);
                // store the imported file(s) and the siteId in an object and save it as
                // a variable in patientsStore
                store_1.patientsStore.importedFileAndSitesIds = {
                    accepted,
                    sitesIds: this.sitesSelectedIds
                };
                router_1.RouteManager.transitionTo(`/patients/import/select`);
            }
        };
    }
    get availableOptions() {
        if (store_2.sitesListStore.sites.value) {
            const siteIds = this.sitesList.map(site => site.id);
            const siteOptions = store_2.sitesListStore.sites.value.filter(site => siteIds.indexOf(site.id) < 0);
            return siteOptions.map((site, i) => ({
                id: site.id,
                label: site.displayName || site.name || "No name (for label)",
                value: site.id.toString(),
                tokenLabel: site.displayName || site.name || "No name (for tokenLabel)"
            }));
        }
        return [];
    }
    componentWillMount() {
        // sitesListStore.loadSites();
        store_2.sitesListStore.loadSitesNoRelation();
        this.resetSite();
    }
    componentWillUnmount() {
        store_1.patientsStore.reset();
        this.resetSite();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    resetSite() {
        // if (usersStore.user.value && usersStore.user.value.siteUser) {
        //   this.siteSelected = true;
        // } else {
        //   this.siteSelected = false;
        // }
        this.siteSelected = false;
    }
    render() {
        return (React.createElement("div", { className: "patients-submit" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("h2", null, "Import Patients")),
            !store_1.patientsStore.submitted &&
                (!store_1.patientsStore.submission.value ||
                    store_1.patientsStore.submission.value.length === 0) && (React.createElement(paper_1.MaterialPaper, { className: "patients-submit__submission" },
                !this.siteSelected && (React.createElement("form", { className: "patients-submit__site-form" },
                    React.createElement("p", null,
                        React.createElement("strong", null, "Please Select a Pharmacy Before Submission")),
                    React.createElement(multi_select_1.UiMultiSelect, { className: "patients-submit__site-multi-select", label: "Pharmacy *", missing: false, options: this.availableOptions, values: this.getMultiSelectValues(), onChange: values => this.onChangeMultiSelect(values) }),
                    React.createElement(button_1.MaterialButton, { className: "patients-submit__site-button", primary: true, onClick: this.handleClickNext, disabled: !this.sitesList.length }, "Next"))),
                React.createElement(ui_1.UiDropzone, { className: "patients-submit__dropzone", onDrop: this.handleDrop, loading: store_1.patientsStore.submission.loading },
                    React.createElement(Backup_1.default, { className: "patients-submit__download-icon" }),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Drag & Drop Patients File"),
                        React.createElement("br", null),
                        React.createElement("small", null, "(.csv only)")),
                    React.createElement("div", { className: "patients-submit__dropzone-button" },
                        React.createElement(button_1.MaterialButton, { flat: true, className: "browse-button" }, "Browse to Upload"))))),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
    // private handleChangeSite = (id: string) => {
    //   this.siteId = id;
    // };
    onChangeMultiSelect(values) {
        this.sitesList = store_2.sitesListStore.sites.value
            ? store_2.sitesListStore.sites.value.filter(site => values.map(value => value.value).indexOf(String(site.id)) >= 0)
            : [];
    }
};
__decorate([
    mobx_1.computed
], PatientsImport.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], PatientsImport.prototype, "patient", void 0);
__decorate([
    mobx_1.observable
], PatientsImport.prototype, "sitesSelectedIds", void 0);
__decorate([
    mobx_1.observable
], PatientsImport.prototype, "sitesList", void 0);
__decorate([
    mobx_1.observable
], PatientsImport.prototype, "siteSelected", void 0);
PatientsImport = __decorate([
    mobx_react_1.observer
], PatientsImport);
exports.PatientsImport = PatientsImport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-import/patients-import.tsx
// module id = 3812
// module chunks = 0